import Icon from '../components/Icon.vue'

Icon.register({
  'bell-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1c7 5.4 8.2 15.5 2.8 22.5l-19.6 25.3c-5.4 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.5-2.8-22.5l19.6-25.3c5.4-7 15.5-8.2 22.5-2.8l145 112c22.9-31.5 57.3-54.2 97.6-62.6v-20.8c0-17.7 14.3-32 32-32s32 14.3 32 32v20.8c73.5 15.3 127.9 77.5 127.9 155.2 0 102.3 36.2 133.5 55.5 154.3 6 6.4 8.7 14.2 8.6 21.7 0 1.4-0.6 2.7-0.8 4.1zM157.2 251.5l212.8 164.5h-241.9c-19.1 0-32-15.6-32.1-32 0-7.5 2.6-15.3 8.6-21.7 16.2-17.4 44-42.8 52.6-110.8zM320 512c-35.3 0-64-28.7-64-64h127.9c0 35.3-28.6 64-64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bell-slash.js
// module id = 1030
// module chunks = 0